export default __webpack_public_path__ + "static/media/P20005.4b066ab6.png";